import { combineReducers } from "redux"
import { NONE_ORDER_KEY } from "../../Config"
import { DEFAULT_FRAME_JUMP } from "../../Config"
import { mergeEvents } from "../../Components/TaskDetails/EventsSection/util"

const video = (state = { highlightedPeople: [], isPrefetchingCompleted: false }, action) => {
  switch (action.type) {
    case "HIGHLIGHT_PERSON": {
      let nhighlightedPeople = []
      if (!action.unhighlightOthers) {
        nhighlightedPeople = [...state.highlightedPeople]
      }
      if (action.person) {
        if (!nhighlightedPeople.includes(action.person)) {
          nhighlightedPeople.push(action.person)
        }
      }
      return {
        ...state,
        highlightedPeople: nhighlightedPeople,
      }
    }
    case "UNHIGHLIGHT_PERSON": {
      return {
        ...state,
        highlightedPeople: state.highlightedPeople.filter((hPerson) => hPerson !== action.person),
      }
    }
    case "VIDEO_CLEAR_HIGHLIGHT_PERSON": {
      return {
        ...state,
        highlightedPeople: [],
      }
    }
    case "SET_IS_PREFETCHING_COMPLETED": {
      return {
        ...state,
        isPrefetchingCompleted: action.isPrefetchingCompleted,
      }
    }
    default:
      return state
  }
}

const layout = (state = { infoMode: true }, action) => {
  switch (action.type) {
    case "INFO_MODE":
      return {
        ...state,
        infoMode: action.infoMode,
      }
    default:
      return state
  }
}

/**
 * Data used to solve the task
 *
 * task
 * {
 *  selectedOrders: [<orderId>, <orderId2>,...],
 *  ordersDetails: {
 *    <orderId>: {
 *      ...redisOrderData,
 *    },
 *    <orderId>: {
 *      ...redisOrderData,
 *    },
 *  ...
 *  }
 * }
 */
const task = (
  state = {
    selectedOrders: [],
    ordersDetails: {},
    selectedOrderId: NONE_ORDER_KEY,
  },
  action
) => {
  switch (action.type) {
    case "SET_TASK": {
      return {
        ...state,
        task: action.task,
      }
    }
    case "TASK_SELECT_ORDER": {
      let nselectedOrders = []
      if (!action.unselectOthers) {
        nselectedOrders = [...state.selectedOrders]
      }
      if (action.orderId) {
        if (!nselectedOrders.includes(action.orderId)) {
          nselectedOrders.push(action.orderId)
        }
      }
      return {
        ...state,
        selectedOrders: nselectedOrders,
      }
    }
    case "TASK_UNSELECT_ORDER": {
      return {
        ...state,
        selectedOrders: state.selectedOrders.filter((sOrder) => sOrder !== action.orderId),
      }
    }
    case "TASK_CLEAR_SELECTED_ORDERS": {
      return {
        ...state,
        selectedOrders: [],
      }
    }
    case "TASK_SET_ORDER_DETAILS": {
      if (action.orderDetails && action.orderDetails.id) {
        return {
          ...state,
          ordersDetails: {
            ...state.ordersDetails,
            [action.orderDetails.id]: { ...action.orderDetails },
          },
        }
      }
      return state
    }
    case "SELECT_ORDER_ID": {
      if (action.orderId) {
        return {
          ...state,
          selectedOrderId: action.orderId,
        }
      }
      break
    }
    default:
      return state
  }
}

const videoPlay = (
  state = {
    autoPlay: true,
    reverseAutoPlay: false,
    numOfFramesToJump: Number(sessionStorage.getItem("videoSpeed")) || DEFAULT_FRAME_JUMP,
  },
  action
) => {
  switch (action.type) {
    case "SET_VIDEO_AUTO_PLAY": {
      return {
        ...state,
        autoPlay: action.autoPlay,
      }
    }
    case "SET_VIDEO_REVERSE_AUTO_PLAY": {
      return {
        ...state,
        reverseAutoPlay: action.reverseAutoPlay,
      }
    }
    case "SET_NUMBER_OF_FRAMES_TO_JUMP": {
      let numOfFramesToJump = action.numOfFramesToJump
      if (numOfFramesToJump >= 15) {
        numOfFramesToJump = DEFAULT_FRAME_JUMP
      } else if (numOfFramesToJump < DEFAULT_FRAME_JUMP) {
        numOfFramesToJump = 14
      }
      console.log("Frame jump set to ", numOfFramesToJump)
      return {
        ...state,
        numOfFramesToJump,
      }
    }
    default:
      return state
  }
}

const dialog = (state = { userMessage: "", dialogOpen: false, alertOpen: false }, action) => {
  switch (action.type) {
    case "SET_USER_MESSAGE": {
      return {
        ...state,
        userMessage: action.userMessage,
      }
    }
    case "SET_DIALOG_OPEN": {
      return {
        ...state,
        dialogOpen: action.dialogOpen,
      }
    }
    case "SET_ALERT_OPEN": {
      return {
        ...state,
        alertOpen: action.alertOpen,
      }
    }
    default:
      return state
  }
}

const notification = (state = { notificationList: [] }, action) => {
  switch (action.type) {
    case "SET_NOTIFICATION_LIST": {
      return {
        ...state,
        notificationList: action.notificationList,
      }
    }
    default:
      return state
  }
}

const annotationData = (state = { rawTrackList: {}, formattedOrderTracks: {} }, action) => {
  switch (action.type) {
    case "SET_RAWTRACK_LIST": {
      return {
        ...state,
        rawTrackList: Object.assign(state.rawTrackList, action.rawTrackList),
      }
    }
    case "SET_ORDERTRACK_LIST": {
      return {
        ...state,
        formattedOrderTracks: Object.assign(
          state.formattedOrderTracks,
          action.formattedOrderTracks
        ),
      }
    }
    default:
      return state
  }
}

const cameraData = (
  state = {
    cameraList: [],
    cameraListOptions: [],
    cameraListDetails: {},
    cameraNavigationList: {},
  },
  action
) => {
  switch (action.type) {
    case "SET_CAMERA_LIST": {
      return {
        ...state,
        cameraList: action.cameraList,
      }
    }
    case "SET_CAMERA_LIST_OPTIONS": {
      return {
        ...state,
        cameraListOptions: action.cameraListOptions,
      }
    }
    case "SET_CAMERA_LIST_DETAILS": {
      return {
        ...state,
        cameraListDetails: action.cameraListDetails,
      }
    }
    case "SET_CAMERA_NAVIGATION_LIST": {
      return {
        ...state,
        cameraNavigationList: action.cameraNavigationList,
      }
    }
    default:
      return state
  }
}

const verifyCart = (
  state = {
    isEditingCart: false,
    itemsToAdd: [],
    cartItems: [],
    editedCartItems: [],
    isEditingEvents: false,
    events: [],
    editedEvents: [],
    duplicateScanEvent: {},
  },
  action
) => {
  switch (action.type) {
    case "SET_IS_EDITING_CART": {
      return {
        ...state,
        isEditingCart: action.isEditingCart,
      }
    }
    case "SET_ITEMS_TO_ADD": {
      return {
        ...state,
        itemsToAdd: action.itemsToAdd,
      }
    }
    case "RESET_ITEMS_TO_ADD": {
      return {
        ...state,
        itemsToAdd: [],
      }
    }
    case "SET_CART_ITEMS": {
      return {
        ...state,
        cartItems: action.cartItems,
      }
    }
    case "SET_EDITED_CART_ITEMS": {
      return {
        ...state,
        editedCartItems: action.editedCartItems,
      }
    }
    case "SET_IS_EDITING_EVENTS": {
      return {
        ...state,
        isEditingEvents: action.isEditingEvents,
      }
    }
    case "SET_EVENTS": {
      return {
        ...state,
        events: action.events,
      }
    }
    case "SET_EDITED_EVENTS": {
      return {
        ...state,
        editedEvents: action.editedEvents,
      }
    }
    case "MERGE_EVENTS": {
      return {
        ...state,
        events: mergeEvents(action.newEvents, state.events),
      }
    }
    case "MERGE_EDITED_EVENTS": {
      return {
        ...state,
        editedEvents: mergeEvents(action.newEvents, state.editedEvents),
      }
    }
    case "SET_DUPLICATE_SCAN_EVENT": {
      return {
        ...state,
        duplicateScanEvent: action.duplicateScanEvent,
      }
    }
    default:
      return state
  }
}

const combinedReducer = combineReducers({
  video,
  layout,
  task,
  videoPlay,
  dialog,
  notification,
  annotationData,
  cameraData,
  verifyCart,
})

const rootReducer = (state, action) => {
  // action to reset redux store to initial state
  if (action.type === "RESET") {
    // reducers return the initial state when they are called with undefined as the first argument. So setting up the state as undefined
    state = undefined
  }
  return combinedReducer(state, action)
}

export default rootReducer
